import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// App-shell service worker: lets the register refresh/reopen during an Internet outage. Static assets only.
// When an updated worker takes control (new app revision), reload once so the page never keeps running a stale bundle.
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  let reloaded = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => { if (navigator.serviceWorker.controller && !reloaded) { reloaded = true; window.location.reload(); } });
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").then((reg) => reg.update()).catch(() => {}));
}
// While offline, background fetches that nobody awaited reject with a plain Network Error; they are expected and
// already reflected by the connectivity banner, so keep them out of the console / dev overlay.
window.addEventListener("unhandledrejection", (e) => {
  const r = e.reason;
  if (r && r.isAxiosError && !r.response) e.preventDefault();
});
